import { createFileRoute } from '@tanstack/react-router';

import Loading from '@/_pages/settings/manufacturers/new/loading';

export const Route = createFileRoute('/_private/settings/manufacturers/new')({
  component: Loading,
});
